export const GET_ORGANIZATIONS = 'organizations/GET_ORGANIZATIONS';
export const GET_ORGANIZATIONS_SUCCESS = 'organizations/GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAILED = 'organizations/GET_ORGANIZATIONS_FAILED';
export const GET_SINGLE_ORGANIZATIONS = 'organizations/GET_SINGLE_ORGANIZATIONS';
export const GET_SINGLE_ORGANIZATIONS_SUCCESS = 'organizations/GET_SINGLE_ORGANIZATIONS_SUCCESS';
export const GET_SINGLE_ORGANIZATIONS_FAILED = 'organizations/GET_SINGLE_ORGANIZATIONS_FAILED';
export const UPDATE_ORGANIZATIONS = 'organizations/UPDATE_ORGANIZATIONS';
export const UPDATE_ORGANIZATIONS_SUCCESS = 'organizations/UPDATE_ORGANIZATIONS_SUCCESS';
export const UPDATE_ORGANIZATIONS_FAILED = 'organizations/UPDATE_ORGANIZATIONS_FAILED';
